// redux store using toolkit
import { configureStore } from "@reduxjs/toolkit";
import { GetActionReducer } from "./reducer/TempReducer";
import {
    GetLandingPageReducer, GetUserInfoV2LandingPageReducer, GetBlankCategoriesReducer, GetSpendCardDataReducer,
    GetSupplierPerfCardDataReducer, GetContractCardDataReducer, GetMarketIntelInHouseCardDataReducer,
    GetSustainabilityCardDataReducer, GetMaxDateReducer,
    GetArchletCardDataReducer, GetTileKpiOverviewReducer, GetR2PInsightsCardDataReducer, GetProcurementPageReducer,
    GetArgoToolsPageReducer, GetUserInfoReducer, GetUserAccessReducer, GetTaxonomyReducer
} from "./reducer/LandingPageReducer";
import { GetSpendDetailReducer } from "./reducer/SpendModalReducer";

import { GetSupplierNamesReducer, GetSupplierPerfFilterDetailsReducer, GetSupplierPerfInhouseReducer, GetSupplierPerfReducer, GetSupplierPerfVendorListReducer, GetSPMSupplierDetailsReducer } from "./reducer/SupplierPerfReducer";
import { GetArchletDetailReducer, GetContractDetailReducer, GetArchletDropdownReducer, GetAribaDropdownReducer, GetAribaKpiReducer } from "./reducer/ContractModalReducer";
import { GetMarketIntelDetailReducer, GetMarketIntelInHouseDetailReducer, GetSmartCubeCategoryReducer } from "./reducer/MarketIntelReducer";


import { GetSustainabilityFilterDetailsReducer, GetSustainabilityReducer, GetSustainabilityDropdownDetailsReducer, FetchSustainabilitySupplierDetailsReducer } from "./reducer/SustainabilityReducer";
import localDataReducer from "./reducer/localDataSlice";
import loaderReducer from "./reducer/loaderSlice"
import { GetCompassCardReducer, GetCompassDetailReducer, GetCompassDropdownReducer, GetCompassDropdownV2Reducer, GetCompassKpiPageHeaderReducer,
    GetCompassSectorBuChartReducer,
    GetCompassSectorCategoryChartReducer,
    GetCompassCoverageReportChartReducer,
    GetCompassExecutiveSummaryReducer } from "./reducer/CommodityBuyPlanReducer";
import { GetPowerSteeringKpiReducer, GetPowerSteeringMainReducer } from "./reducer/SavingsReportingReducer";
import { GetSCMKpiReducer, GetSCMMainReducer } from "./reducer/SCMReducer";
import { GetImarcDetailReducer, GetImarcDropdownReducer, GetImarcSecondaryDropdownReducer } from "./reducer/ImarcReducer";
import { GetMyRISDropdownReducer, GetMyRISDetailReducer } from "./reducer/MyRISReducer";
import { GetRISIDropdownV2Reducer, GetRISISecondaryDropdownV2Reducer, GetRISIDetailV2Reducer, GetRISIDropdownReducer, GetRISIDetailReducer, GetRISISecondaryDropdownReducer, GetCommodityLandingReducer, GetNewsDropdownReducer, GetNewsSecondaryDropdownReducer, GetNewsDropdownDataReducer, GetAllNewsListReducer, GetNewsDetailReducer, GetUpdateBookmarkReducer, GetBookmarkListReducer, GetShareListReducer, GetShareNewsEmailReducer } from "./reducer/RISIReducer";
import { GetVeridionKpiReducer } from "./reducer/VeridionReducer";
import { GetForeStreetKpiReducer, GetForeStreetMainReducer } from "./reducer/ForestreetReducer";
import { FetchResiliencDropdownFilterReducer, FetchResiliencFilterReducer, FetchResilincMainReducer,FetchResilincDetailReducer, FetchResilincFilterReducer  } from "./reducer/SupplierRiskReducer";
import { GetNpsKpiReducer, CancelNpsKpiReducer, CancelWalkmeAccessReducer } from "./reducer/NpsReducer";
import { GetNpsAdminReducer } from "./reducer/NpsAdminReducer"
import { GetSaveTilesOrderReducer } from "./reducer/KpiCardsTileReducer";
import { GetResetToDefaultTilesOrderReducer } from "./reducer/KpiCardsTileReducer";
import { GetExImDropdownReducer, GetExImSecondaryDropdownReducer, GetExImMonthlyReportReducer, GetExImCountryReportReducer } from "./reducer/ExImReducer";
import { UpdateSubscribeReducer, FetchNotificationsReducer, ReadNotificationReducer, ReadAllNotificationReducer } from "./reducer/BroadcastAppBellReducer";
import { GetAllNotificationReducer, GetDeleteNotificationReducer, GetSaveNotificationReducer, GetPublishNotificationReducer } from "./reducer/NotificationReducer";
import { GetSBACCIDateReducer, GetSBACCIDetailReducer, GetCommodityLandingSBACCIReportCountReducer, GetCMAPageFilterReducer,GetCMALineChartReducer,GetCMATableReducer,GetCMADateReducer,GetCmaDetailReportReducer, GetWoodmacPageFilterReducer, GetWoodmacLineChartReducer, GetWoodmacTableReducer, GetWoodmacDateReducer, GetWoodmacDetailReportReducer } from "./reducer/SBACCIReducer";
// import { GetCategoryForumConfigReducer, GetCategoryForumTableReducer } from "./reducer/CategoryForumReducer";
// import { GetSBACCIDateReducer, GetSBACCIDetailReducer, GetCommodityLandingSBACCIReportCountReducer, GetCMAPageFilterReducer,GetCMALineChartReducer,GetCMATableReducer,GetCMADateReducer,GetCmaDetailReportReducer } from "./reducer/SBACCIReducer";
import {
    GetCategoryForumConfigReducer,
    GetCategoryForumTableReducer,
    GetCategoryForumYearToDateReducer,
    GetCategoryForumForumsByCategoryReducer,
    GetCategoryForumBalanceOfTheYearReducer,
    GetCategoryForumSummaryReducer,
    GetCategoryForumContractBoardsDetailsReducer,
    GetCategoryForumActionTrackerFiltersReducer,
    GetCategoryForumActionTrackerHeaderDataReducer,
    GetCategoryForumActionTrackerTabularDataReducer,
    GetCategoryForumActionTrackerChartDataReducer,
    GetCategoryForumOutcomeSummaryFiltersReducer,
    GetCategoryForumOutcomeSummaryTabularDataReducer,
    GetYourCategoryForumUserCalendarReducer
} from "./reducer/CategoryForumReducer";
import { GetEMEASectorSiteCardReducer, GetOneNASectorSiteCardReducer, GetGlobalPackagingSectorSiteCardReducer, GetSupplierPassportSectorSiteCardReducer } from "./reducer/SectorSitesReducer";
import { GetMIL1Reducer, GetMIL2Reducer, GetIsFavoriteL1Reducer, GetIsFavoriteL1L2Reducer } from "./reducer/CommodityPackagingReducer";
import { GetSPGlobalPageLabelCountReducer, GetSPGlobalPageFilterReducer, GetSPGlobalLineChartReducer, GetSPGlobalTableReducer, GetSPGlobalDateReducer, GetSPGlobalDetailReportReducer } from "./reducer/SPGlobalReducer";
import { GetSmartCubePageFilterReducer, GetSmartCubeChartFiltersReducer, GetSmartCubeMarketSizeForecastReducer, GetSmartCubeCategoryRiskReducer, GetSmartCubeTextWidgetsReducer, GetSmartCubePriceTrendReducer, GetSmartCubeCostDriversReducer, GetSmartCubeCostStructureBreakdownReducer } from "./reducer/SmartCubeReducer";
import { get } from "@okta/okta-auth-js";
const isDevelopment = window.ENV === "DEV";

const middleware = (getDefaultMiddleware) =>
    isDevelopment ? getDefaultMiddleware().concat() : getDefaultMiddleware();

export const store = configureStore({
    devTools: isDevelopment,
    middleware,
    reducer: {
        localData: localDataReducer,
        loader: loaderReducer,
        getLandingPageReducer: GetLandingPageReducer,
        getUserInfoV2LandingPageReducer: GetUserInfoV2LandingPageReducer,
        getBlankCategoriesReducer: GetBlankCategoriesReducer,
        getSpendCardDataReducer: GetSpendCardDataReducer,
        getSupplierPerfCardDataReducer: GetSupplierPerfCardDataReducer,
        getContractCardDataReducer: GetContractCardDataReducer,
        getSpendDetailReducer: GetSpendDetailReducer,
        GetSupplierPerfReducer: GetSupplierPerfReducer,
        getContractDetailReducer: GetContractDetailReducer,
        getMarketIntelDetailReducer: GetMarketIntelDetailReducer,
        getMarketIntelInHouseDetailReducer: GetMarketIntelInHouseDetailReducer,
        getMarketIntelInHouseCardDataReducer: GetMarketIntelInHouseCardDataReducer,
        getSustainabilityDetailReducer: GetSustainabilityReducer,
        getSupplierNames: GetSupplierNamesReducer,
        getSustainabilityCardDataReducer: GetSustainabilityCardDataReducer,
        getSustainabilityFilterDetailsReducer: GetSustainabilityFilterDetailsReducer,
        getSupplierPerfFilterDetailsReducer: GetSupplierPerfFilterDetailsReducer,
        getSupplierPerfInhouseReducer: GetSupplierPerfInhouseReducer,
        getSupplierPerfVendorListReducer: GetSupplierPerfVendorListReducer,
        getMaxDateReducer: GetMaxDateReducer,
        getSmartCubeCategoryReducer: GetSmartCubeCategoryReducer,
        getArchletDetailReducer: GetArchletDetailReducer,
        getArchletCardDataReducer: GetArchletCardDataReducer,
        getCompassCardReducer: GetCompassCardReducer,
        getCompassDetailReducer: GetCompassDetailReducer,
        getCompassKpiPageHeaderReducer: GetCompassKpiPageHeaderReducer,
        getCompassSectorBuChartReducer: GetCompassSectorBuChartReducer,
        getCompassSectorCategoryChartReducer: GetCompassSectorCategoryChartReducer,
        getCompassCoverageReportChartReducer: GetCompassCoverageReportChartReducer,
        getCompassExecutiveSummaryReducer: GetCompassExecutiveSummaryReducer,
        getPowerSteeringKpiReducer: GetPowerSteeringKpiReducer,
        getForeStreetKpiReducer: GetForeStreetKpiReducer,
        getPowerSteeringMainReducer: GetPowerSteeringMainReducer,
        getForeStreetMainReducer: GetForeStreetMainReducer,
        fetchResiliencDropdownFilterReducer: FetchResiliencDropdownFilterReducer,
        fetchResiliencFilterReducer: FetchResiliencFilterReducer,
        fetchResilincMainReducer: FetchResilincMainReducer,
        fetchResilincDetailReducer: FetchResilincDetailReducer,
        getSCMKpiReducer: GetSCMKpiReducer,
        getSCMMainReducer: GetSCMMainReducer,
        getVeridionKpiReducer: GetVeridionKpiReducer,
        getNpsKpiReducer: GetNpsKpiReducer,
        cancelNpsKpiReducer: CancelNpsKpiReducer,
        cancelWalkmeAccessReducer: CancelWalkmeAccessReducer,
        getNpsAdminReducer: GetNpsAdminReducer,
        getSaveTilesOrderReducer: GetSaveTilesOrderReducer,
        getTileKpiOverviewReducer: GetTileKpiOverviewReducer,
        getArchletDropdownReducer: GetArchletDropdownReducer,
        fetchResilincFilterReducer: FetchResilincFilterReducer,
        getAribaDropdownReducer: GetAribaDropdownReducer,
        getAribaKpiReducer: GetAribaKpiReducer,
        getResetToDefaultTilesOrderReducer: GetResetToDefaultTilesOrderReducer,
        getSPMSupplierDetailsReducer: GetSPMSupplierDetailsReducer,
        getSustainabilityDropdownDetailsReducer: GetSustainabilityDropdownDetailsReducer,
        fetchSustainabilitySupplierDetailsReducer: FetchSustainabilitySupplierDetailsReducer,
        getMyRISDropdownReducer: GetMyRISDropdownReducer,
        getMyRISDetailReducer: GetMyRISDetailReducer,
        getR2PInsightsCardDataReducer: GetR2PInsightsCardDataReducer,
        getRISIDropdownReducer: GetRISIDropdownReducer,
        getRISIDropdownV2Reducer: GetRISIDropdownV2Reducer,
        getRISISecondaryDropdownReducer: GetRISISecondaryDropdownReducer,
        getRISISecondaryDropdownV2Reducer: GetRISISecondaryDropdownV2Reducer,
        getRISIDetailReducer: GetRISIDetailReducer,
        getRISIDetailV2Reducer: GetRISIDetailV2Reducer,
        getCommodityLandingReducer: GetCommodityLandingReducer,
        getProcurementPageReducer: GetProcurementPageReducer,
        getNewsDropdownReducer: GetNewsDropdownReducer,
        getNewsSecondaryDropdownReducer: GetNewsSecondaryDropdownReducer,
        getNewsDropdownDataReducer: GetNewsDropdownDataReducer,
        getAllNewsListReducer: GetAllNewsListReducer,
        getNewsDetailReducer: GetNewsDetailReducer, 
        getUpdateBookmarkReducer: GetUpdateBookmarkReducer,
        getBookmarkListReducer: GetBookmarkListReducer,
        getImarcDropdownReducer: GetImarcDropdownReducer,
        getImarcSecondaryDropdownReducer: GetImarcSecondaryDropdownReducer,
        getImarcDetailReducer: GetImarcDetailReducer,
        getShareListReducer: GetShareListReducer,
        getShareNewsEmailReducer: GetShareNewsEmailReducer,
        getExImDropdownReducer: GetExImDropdownReducer,
        getExImSecondaryDropdownReducer: GetExImSecondaryDropdownReducer,
        getExImMonthlyReportReducer: GetExImMonthlyReportReducer,
        getExImCountryReportReducer: GetExImCountryReportReducer,
        getArgoToolsPageReducer: GetArgoToolsPageReducer,
        updateSubscribeReducer: UpdateSubscribeReducer,
        fetchNotificationsReducer: FetchNotificationsReducer,
        readNotificationReducer: ReadNotificationReducer,
        readAllNotificationReducer: ReadAllNotificationReducer,
        getAllNotificationReducer: GetAllNotificationReducer,
        getSaveNotificationReducer: GetSaveNotificationReducer,
        getDeleteNotificationReducer: GetDeleteNotificationReducer,
        getPublishNotificationReducer: GetPublishNotificationReducer,
        getSBACCIDateReducer: GetSBACCIDateReducer,
        getSBACCIDetailReducer: GetSBACCIDetailReducer,
        getCategoryForumConfigReducer: GetCategoryForumConfigReducer,
        getCategoryForumTableReducer: GetCategoryForumTableReducer,
        getCategoryForumYearToDateReducer: GetCategoryForumYearToDateReducer,
        getCategoryForumForumsByCategoryReducer: GetCategoryForumForumsByCategoryReducer,
        getCategoryForumBalanceOfTheYearReducer: GetCategoryForumBalanceOfTheYearReducer,
        getCategoryForumSummaryReducer: GetCategoryForumSummaryReducer,
        getCategoryForumContractBoardsDetailsReducer: GetCategoryForumContractBoardsDetailsReducer,
        getCategoryForumActionTrackerFiltersReducer: GetCategoryForumActionTrackerFiltersReducer,
        getCategoryForumActionTrackerHeaderDataReducer: GetCategoryForumActionTrackerHeaderDataReducer,
        getCategoryForumActionTrackerTabularDataReducer: GetCategoryForumActionTrackerTabularDataReducer,
        getCategoryForumActionTrackerChartDataReducer: GetCategoryForumActionTrackerChartDataReducer,
        getCategoryForumOutcomeSummaryFiltersReducer: GetCategoryForumOutcomeSummaryFiltersReducer,
        getCategoryForumOutcomeSummaryTabularDataReducer: GetCategoryForumOutcomeSummaryTabularDataReducer,
        getYourCategoryForumUserCalendarReducer: GetYourCategoryForumUserCalendarReducer,
        getCommodityLandingSBACCIReportCountReducer: GetCommodityLandingSBACCIReportCountReducer,
        getCompassDropdownReducer: GetCompassDropdownReducer,
        getCompassDropdownV2Reducer: GetCompassDropdownV2Reducer,
        getEMEASectorSiteCardReducer: GetEMEASectorSiteCardReducer,
        getOneNASectorSiteCardReducer: GetOneNASectorSiteCardReducer,
        getCMAPageFilterReducer: GetCMAPageFilterReducer,
        getCMALineChartReducer: GetCMALineChartReducer,
        getCMATableReducer: GetCMATableReducer,
        getCMADateReducer: GetCMADateReducer,
        getCmaDetailReportReducer: GetCmaDetailReportReducer,
        getWoodmacPageFilterReducer: GetWoodmacPageFilterReducer,
        getWoodmacLineChartReducer: GetWoodmacLineChartReducer,
        getWoodmacTableReducer: GetWoodmacTableReducer,
        getWoodmacDateReducer: GetWoodmacDateReducer,
        getWoodmacDetailReportReducer: GetWoodmacDetailReportReducer,
        getUserInfoReducer: GetUserInfoReducer,
        getTaxonomyReducer: GetTaxonomyReducer,
        getUserAccessReducer: GetUserAccessReducer,
        getGlobalPackagingSectorSiteCardReducer: GetGlobalPackagingSectorSiteCardReducer,
        getSupplierPassportSectorSiteCardReducer: GetSupplierPassportSectorSiteCardReducer,
        getMIL1Reducer: GetMIL1Reducer,
        getMIL2Reducer: GetMIL2Reducer,
        getIsFavoriteL1Reducer: GetIsFavoriteL1Reducer,
        getIsFavoriteL1L2Reducer: GetIsFavoriteL1L2Reducer,
        getSPGlobalPageLabelCountReducer: GetSPGlobalPageLabelCountReducer,
        getSPGlobalPageFilterReducer: GetSPGlobalPageFilterReducer,
        getSPGlobalLineChartReducer: GetSPGlobalLineChartReducer,
        getSPGlobalTableReducer: GetSPGlobalTableReducer,
        getSPGlobalDateReducer: GetSPGlobalDateReducer,
        getSPGlobalDetailReportReducer: GetSPGlobalDetailReportReducer,
        getSmartCubePageFilterReducer: GetSmartCubePageFilterReducer,
        getSmartCubeChartFiltersReducer: GetSmartCubeChartFiltersReducer,
        getSmartCubeMarketSizeForecastReducer: GetSmartCubeMarketSizeForecastReducer,
        getSmartCubeCategoryRiskReducer: GetSmartCubeCategoryRiskReducer,
        getSmartCubeTextWidgetsReducer: GetSmartCubeTextWidgetsReducer,
        getSmartCubePriceTrendReducer: GetSmartCubePriceTrendReducer,
        getSmartCubeCostDriversReducer: GetSmartCubeCostDriversReducer,
        getSmartCubeCostStructureBreakdownReducer: GetSmartCubeCostStructureBreakdownReducer
    },
});
